module.exports = __webpack_public_path__ + "img/xxw.4d53eb3c.jpg";